module.exports = __webpack_public_path__ + "static/media/trash-can.a7f471bb.svg";